import React, { useState } from "react";

export default function ReportCardModal({ student, onClose, onSave }) {
  const [examName, setExamName] = useState("");
  const [term, setTerm] = useState("");
  const [subjectMarks, setSubjectMarks] = useState("");
  const [remarks, setRemarks] = useState("");

  const submit = (e) => {
    e.preventDefault();
    onSave({ examName, term, subjectMarks, remarks });
  };

  if (!student) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white rounded-lg w-full max-w-xl p-6 shadow-lg">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-xl font-semibold">Report Card — {student.firstName}</h3>
          <button onClick={onClose} className="text-gray-600">✕</button>
        </div>

        <form onSubmit={submit} className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label>Exam Name</label>
            <input value={examName} onChange={(e) => setExamName(e.target.value)} className="w-full border px-3 py-2 rounded" required />
          </div>
          <div>
            <label>Term</label>
            <input value={term} onChange={(e) => setTerm(e.target.value)} className="w-full border px-3 py-2 rounded" required />
          </div>

          <div className="md:col-span-2">
            <label>Subject Marks</label>
            <textarea
              value={subjectMarks}
              onChange={(e) => setSubjectMarks(e.target.value)}
              placeholder="e.g. Mathematics: 90, Science: 85, English: 88"
              className="w-full border px-3 py-2 rounded"
              required
            />
          </div>

          <div className="md:col-span-2">
            <label>Remarks</label>
            <textarea value={remarks} onChange={(e)=>setRemarks(e.target.value)} className="w-full border px-3 py-2 rounded" />
          </div>

          <div className="md:col-span-2 flex justify-end gap-3 mt-2">
            <button type="button" onClick={onClose} className="px-4 py-2 border rounded">Cancel</button>
            <button type="submit" className="px-4 py-2 bg-green-600 text-white rounded">Save Report</button>
          </div>
        </form>
      </div>
    </div>
  );
}
